
const VERSION = {
  SHA1:'1779e549daa3b61b164f81af59abfe1f2e14f141',
  VERSION:2317,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
